import * as React from 'react';

function SvgSearchResultArrowIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 11" {...props}>
    <path stroke="#363D43" strokeWidth={2} d="m7.267 1 4.31 4.31-4.31 4.31M0 5.14h11.236" />
  </svg>)
}
export default SvgSearchResultArrowIcon;
